module.exports = __webpack_public_path__ + "media/favicon/favicon-a58ec6e9.ico";